import { API } from "@web/api";
import { logger } from "@web/lib/logger";
import type { StoreDeps } from "@repo/share-log-stores";

export const storeDeps: StoreDeps = { api: API, logger };
